import loadable from '@loadable/component';

export const OrgDashboardApiAccessContainerLoadable = loadable(
  () => import('./OrgDashboardApiAccessContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardApiAccessContainer,
  },
);
